import type { FC } from 'react';

import { FullPageContent } from '@/components/layout/full-page-content';
import { useCurrentAsset } from '@/hooks/use-current-asset';

import { SiteMapContent } from '../components/site-map-content';
import { SiteMapFilters } from '../components/site-map-filters';

export type AlertsPageQueryParams = {
  id?: string;
  filters?: string;
};

export const SiteMap: FC = () => {
  const { asset } = useCurrentAsset();
  return (
    <FullPageContent
      scrollable
      className="grid h-full grid-rows-[min-content_1fr] overflow-hidden"
    >
      {!asset ? (
        <div>
          <SiteMapFilters />
        </div>
      ) : null}
      <div className="size-full overflow-y-auto p-4 md:p-8 xl:px-[3.75rem] xl:pb-4 xl:pt-5">
        <SiteMapContent />
      </div>
    </FullPageContent>
  );
};
